module.exports = __webpack_public_path__ + "media/images/contacts/icon-contacts-02-688af726f2771b29a05ddd9fcc7a6b5b.svg";